import React from 'react';
import { AppBar, Toolbar, Typography, IconButton, TextField, Paper } from '@material-ui/core/';
import SearchIcon from '@material-ui/icons/Search';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import Brightness7Icon from '@material-ui/icons/Brightness7';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import NavDrawer from './navdrawer';
import '../styles/navbar.css';
import CssBaseline from '@material-ui/core/CssBaseline';
import history from '../components/history';
import Theme from '../components/theme';
import * as auth from '../data/firebaseAuth';


const rootClass = "navbar root";
const toolbarClass = "navbar toolbar";
const menuButtonClass = "navbar menuButton";
const burgerClass = "navbar menuButton burger";
const burgerPressedClass = "navbar menuButton burgerpressed";
const titleClass = "navbar title";
const titleTestClass = "navbar titletest";
const searchClass = "navbar search";
const searchDownPostfix = " down";
const searchRootClass = "navbar searchroot";
const swipeoutSuffix = " swipeout";
const swipeinSuffix = " swipein";
const brightnessClass = "navbar brightness";
const disabledSuffix = " disabled";


const titleStrings = ['Grundwissen Mathematik', 'Grundwissen Mathe', 'Mathematik', 'Mathe'].sort(function (a, b) {
    return b.length - a.length;
});;

class NavBar extends React.Component {

    constructor(...args) {
        super(...args);
        this.state = {
            menu: false,
            searchbar: false,
            searchbarDown: false,
            searchbarAnimation: false,
            hideAccount: false,
            loggedIn: false,
            darkmode: Theme.getDarkmode(),
        };
        this.toggleMenu = this.toggleMenu.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.resizeTitle = this.resizeTitle.bind(this);
        this.handleSearchClick = this.handleSearchClick.bind(this);
        this.handleBrightnessClick = this.handleBrightnessClick.bind(this);
    }

    async componentDidMount() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        
        const u = await auth.getCurrentUser();
        let l = u !== null && u !== undefined;
        this.setState({ loggedIn: l });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
        this.resizeTitle();
        const sbd = window.innerWidth < 600;
        if (sbd !== this.state.searchbarDown) {
            this.setState({
                searchbarDown: sbd,
            });
        }
        const ha = window.innerWidth < 400;
        if (ha !== this.state.hideAccount) {
            this.setState({
                hideAccount: ha,
            });
        }
    }

    resizeTitle() {
        if (this.titleElement !== null && this.titleElement !== undefined && this.titleTestElement !== null && this.titleTestElement !== undefined) {
            const fallback = this.titleElement.innerText;
            this.titleElement.innerText = titleStrings[0];
            const maxWidth = this.titleElement.clientWidth;
            //console.log('maximum length: ' + maxWidth);
            for (let element of titleStrings) {
                //console.log('trying: ' + element);
                this.titleTestElement.innerText = element;
                const width = this.titleTestElement.clientWidth;
                //console.log('achieved width: ' + width);
                if (width <= maxWidth) {
                    this.titleElement.innerText = element;
                    //console.log('Using ' + element);
                    return;
                }
            }
            this.titleElement.innerText = fallback;
            console.warn('no title with good width found!');
        }
    }

    componentDidUpdate() {
        this.handleResize();
    }

    render() {

        return (
            <>
                <div className={rootClass}>
                    <CssBaseline />
                    <AppBar position="fixed">
                        <Toolbar className={toolbarClass}>
                            <Typography className={titleClass} onClick={() => history.push('/')} ref={(divElement) => { this.titleElement = divElement }} variant="h3" noWrap>
                                {titleStrings[0]}
                            </Typography>
                            <Typography className={titleTestClass} ref={(divElement) => { this.titleTestElement = divElement }} variant="h3" noWrap>
                                {titleStrings[0]}
                            </Typography>
                            {this.state.searchbar && !this.state.searchbarDown && (<div className={searchRootClass}><Paper className={searchClass + searchDownPostfix + (this.state.searchbarAnimation ? swipeoutSuffix : swipeinSuffix)}><TextField fullWidth onKeyPress={(ev) => { if (ev.key === 'Enter') { ev.preventDefault(); this.handleSearchClick(); } }} id="search" label="Suchen..." variant="outlined" /></Paper></div>)}
                            <IconButton aria-label="search" color="inherit" onClick={this.handleSearchClick}>
                                <SearchIcon />
                            </IconButton>
                            <IconButton aria-label="brightness" color="inherit" onClick={this.handleBrightnessClick} onContextMenu={(e) => e.preventDefault() || Theme.defaultDarkmode() || this.setState({ darkmode: Theme.getDarkmode() })} >
                                <Brightness4Icon className={brightnessClass + (this.state.darkmode ? disabledSuffix : "")} />
                                <Brightness7Icon className={brightnessClass + (this.state.darkmode ? "" : disabledSuffix)} />
                            </IconButton>
                            {this.state.loggedIn && !this.state.hideAccount && (
                                <IconButton aria-label="account" color="inherit" onClick={this.handleAccountClick} href="/account">
                                    <AccountCircleIcon />
                                </IconButton>
                            )}
                            <IconButton className={menuButtonClass} aria-label="display more actions" edge="end" color="inherit" onClick={this.toggleMenu}>
                                <div className={burgerClass + (this.state.menu ? " fadeout" : " fadein")}>M</div>
                                <div className={burgerPressedClass + (this.state.menu ? " fadein" : " fadeout")}>X</div>
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <Toolbar />
                    {this.state.searchbar && this.state.searchbarDown && (<div className={searchRootClass + searchDownPostfix}><Paper className={searchClass + searchDownPostfix + (this.state.searchbarAnimation ? swipeoutSuffix : swipeinSuffix)}><TextField fullWidth onKeyPress={(ev) => { if (ev.key === 'Enter') { ev.preventDefault(); this.handleSearchClick(); } }} id="search" label="Suchen..." variant="outlined" /></Paper></div>)}
                    <NavDrawer isopen={this.state.menu} close={() => this.setState({ menu: false })} />
                </div>
                <Toolbar />
            </>
        );
    }

    handleSearchClick() {
        if (!this.state.searchbar) {
            this.setState({
                searchbar: true,
            });
            return;
        }
        const toSearch = document.getElementById('search').value;
        if (toSearch.length <= 0) {
            this.setState({
                searchbarAnimation: true,
            });
            setTimeout(() => this.setState({ searchbar: false, searchbarAnimation: false }), 1000);
            return;
        }
        // querys of one letter don't make that much sense
        if (toSearch.length > 1) {
            history.push('/search/' + toSearch);
        }
    }

    handleBrightnessClick() {
        const newDarkmode = Theme.toggleDarkmode();
        this.setState({
            darkmode: newDarkmode,
        });
    }

    toggleMenu() {
        this.setState({
            menu: !this.state.menu,
        });
    }
}

export default NavBar;